import { Pipe, PipeTransform } from '@angular/core';
import { getRelativeTimeString } from '@core/constants';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: any) {
    if (!value) {
      return 'Hace mucho tiempo';
    }

    return getRelativeTimeString(new Date(value));
  }
}
